/* eslint-disable react/no-unescaped-entities */
import React from 'react'

const AgbEN = () => {
    return (
        <>
            <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
            <style
                type="text/css"
                dangerouslySetInnerHTML={{
                    __html: 'ol{margin:0;padding:0}table td,table th{padding:0}.c1{background-color:#ffff00;color:#000000;font-weight:700;text-decoration:none;vertical-align:baseline;font-size:15pt;font-family:"Albert Sans";font-style:normal}.c11{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}.c2{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-size:12pt;font-family:"Albert Sans";font-style:normal}.c8{padding-top:0pt;padding-bottom:0pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:left}.c12{color:#000000;font-weight:400;text-decoration:none;vertical-align:baseline;font-family:"Albert Sans";font-style:normal}.c0{padding-top:0pt;padding-bottom:10pt;line-height:1.1500000000000001;orphans:2;widows:2;text-align:justify}.c9{text-decoration-skip-ink:none;-webkit-text-decoration-skip:none;color:#1155cc;text-decoration:underline}.c4{background-color:#ffffff;max-width:451.5pt;padding:72pt 72pt 72pt 72pt}.c5{color:inherit;text-decoration:inherit}.c10{font-size:26pt}.c3{font-size:12pt}.c7{height:11pt}.c6{background-color:#ffff00}.c13{font-size:11pt}.title{padding-top:0pt;color:#000000;font-size:26pt;padding-bottom:3pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}.subtitle{padding-top:0pt;color:#666666;font-size:15pt;padding-bottom:16pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}li{color:#000000;font-size:11pt;font-family:"Albert Sans"}p{margin:0;color:#000000;font-size:11pt;font-family:"Albert Sans"}h1{padding-top:20pt;color:#000000;font-size:20pt;padding-bottom:6pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h2{padding-top:18pt;color:#000000;font-size:16pt;padding-bottom:6pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h3{padding-top:16pt;color:#434343;font-size:14pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h4{padding-top:14pt;color:#666666;font-size:12pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h5{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;orphans:2;widows:2;text-align:left}h6{padding-top:12pt;color:#666666;font-size:11pt;padding-bottom:4pt;font-family:"Albert Sans";line-height:1.1500000000000001;page-break-after:avoid;font-style:italic;orphans:2;widows:2;text-align:left}'
                }}
            />
            <p className="c0">
                <span className="c3">General Terms and Conditions</span>
            </p>
            <p className="c0">
                <span className="c3">As of February 2024</span>
            </p>
            <p className="c0">
                <span className="c2">
                    The following terms and conditions regulate the rental agreement concluded via the website of Wemolo
                    GmbH (hereinafter: Wemolo), which is concluded between the user of the parking space (hereinafter:
                    renter) and the authorized party of the parking space that is the subject of the agreement
                    (hereinafter: lessor). The lessor is the user of these General Terms and Conditions. Wemolo provides
                    the technical requirements (website, input mask) to facilitate the conclusion of the rental
                    contract. Wemolo does not provide any further services (in particular brokerage or agency services).
                    The contact and address details of the landlord will be provided to the tenant by Wemolo upon
                    request. Insofar as the wording of these GTC refers solely to the male form, persons of all genders
                    are included.
                </span>
            </p>
            <p className="c0" id="h.30j0zll">
                <span className="c2">1. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Rental of parking spaces</span>
            </p>
            <p className="c0" id="h.30j0zll-1">
                <span className="c2">
                    1.1 The subject of the contract is the rental of parking spaces for the parking of a car or
                    motorcycle (hereinafter: vehicle) indicated by license plate number at the time of booking. The
                    parking spaces are located on or in private parking lots, parking garages and underground garages
                    managed by Wemolo. Wemolo is authorized by the Lessor to automatically provide interested parties
                    with predefined offers for the conclusion of rental contracts via the website on behalf of the
                    Lessor. Unless expressly agreed otherwise, the tenant is not allocated a specific parking space, but
                    is granted permission to use a parking space of his choice for the booked period in accordance with
                    the contractual conditions. Parking zones displayed in the booking process must be taken into
                    account by the Lessee.
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    1.2 The rental is made for specific periods of time, which can be seen during the booking, during
                    which the renter is entitled (e.g. overnight or at weekends) to park the vehicle specified during
                    the booking on a parking space to be selected by him. Outside of these times, the parking space must
                    be kept free by the renter. Special signage on site (e.g. parking bans, reservations, etc.) must be
                    observed by the renter accordingly.{' '}
                </span>
            </p>
            <p className="c0">
                <span className="c2">2. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Conclusion of contract</span>
            </p>
            <p className="c0">
                <span className="c2">
                    2.1 Interested parties can submit a non-binding rental request via the input mask on the Wemolo
                    website.
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    2.2 Wemolo then automatically checks the availability of a suitable parking space in the managed
                    parking area. If possible, the lessor (automatically via the Wemolo website) then submits an offer
                    to the interested party to conclude a rental agreement. If this offer is accepted, a rental contract
                    is concluded between the interested party and the lessor.{' '}
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    2.3 Wemolo as the operator of the website can reject rental requests at any time without giving
                    reasons. There is no entitlement to the conclusion of a rental contract.
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    2.4 The rented parking space can only be used with the vehicle specified at the time of booking.
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    3. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Relationship to terms and conditions of third
                    parties
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    If, in addition to the booking platform, another service offered by a third party is used on the
                    space managed by Wemolo, the terms and conditions of the booking platform shall take precedence for
                    the tenant upon conclusion of the rental contract in the event of an objection.{' '}
                </span>
            </p>
            <p className="c0">
                <span className="c2">4. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Rent</span>
            </p>
            <p className="c0">
                <span className="c2">
                    4.1 Upon conclusion of the contract, the Lessee undertakes to pay the agreed rent on time.
                </span>
            </p>
            <p className="c0">
                <span className="c2">4.2 The rent can be paid using the payment methods provided online. </span>
            </p>
            <p className="c0">
                <span className="c2">5.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Term of contract</span>
            </p>
            <p className="c0">
                <span className="c3">
                    5.1 The Tenant rents the parking space for the agreed period. An overview of refunds in the event of
                    premature cancellation of the booking can be found in our cancellation conditions:{' '}
                </span>
                <span className="c9 c3">
                    <a className="c5" href="https://go.wemolo.com/legal/cancellation-policy">
                        https://go.wemolo.com/legal/cancellation-policy
                    </a>
                </span>
                <span className="c3">.</span>
                <span className="c2">&nbsp;Any right of cancellation of the Lessee is not limited by this. </span>
            </p>
            <p className="c0">
                <span className="c2">
                    5.2 The Lessor may terminate the rental agreement extraordinarily with a notice period of two weeks
                    if he sells the property on which the parking space is located or otherwise loses his right to rent
                    it out, in particular as a result of termination of the lease.
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    5.3 The right of both parties to extraordinary termination without notice for good cause remains
                    unaffected.{' '}
                </span>
            </p>
            <p className="c0">
                <span className="c3">6. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Use of the parking space</span>
            </p>
            <p className="c0">
                <span className="c2">
                    6.1 Unless otherwise authorized in writing by the Lessor or Wemolo, the parking space may only be
                    used to park the vehicle specified at the time of booking. Only the vehicle specified in the
                    contract may be parked on the rented parking space, which can be identified as such on the basis of
                    the license plate number provided. This does not affect the possibility of using the parking space
                    with other vehicles within the scope of normal public traffic or renting additional parking spaces.
                    The contact person of the lessee is Wemolo.{' '}
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    6.2 If the renter is not also the owner of the specified vehicle, he is obliged to ensure that the
                    vehicle owner also agrees to the use of the parking space before renting it.{' '}
                </span>
            </p>
            <p className="c0">
                <span className="c2">6.3 The Renter may not store any other objects on the parking space. </span>
            </p>
            <p className="c0">
                <span className="c2">
                    6.4 The Lessee must observe the road traffic regulations. The parking of vehicles without or without
                    recognizable registration plates or with leaking fuel systems or other defects that endanger the
                    operation of the parking facility is not permitted. The parking of vehicles with liquid gas is
                    generally prohibited in underground car parks. The unnecessary running of engines and other odor and
                    noise pollution must be avoided. Cleaning or refueling the vehicle or working on it is not permitted
                    in the parking space or the entire parking area.
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    6.5 The parking lot is not secured against theft and vandalism. The Lessee is responsible for
                    protecting his vehicle and any objects in it against unauthorized theft by third parties.{' '}
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    7.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Subletting and towing of illegally parked
                    vehicles
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    7.1 Subletting or transfer of use to third parties free of charge is only permitted with the
                    Lessor's permission.{' '}
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    7.2 The Lessor reserves the right to tow away vehicles parked illegally on the rented parking space
                    at the owner's expense. Illegally parked vehicles are those that have not been specified for use of
                    the parking space in the rental agreement or that violate Section 6.4.
                </span>
            </p>
            <p className="c0">
                <span className="c2">8.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Liability of the tenant</span>
            </p>
            <p className="c0">
                <span className="c2">
                    The renter is liable for soiling (e.g. caused by oil or petrol) and for all damage caused by himself
                    or by others when using the parking space or as a result of non-compliance with contractual or
                    statutory regulations.{' '}
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    Persons to whom he has permitted the use of his motor vehicle or the parking space.{' '}
                </span>
            </p>
            <p className="c0">
                <span className="c2">9.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Liability of the Lessor</span>
            </p>
            <p className="c0">
                <span className="c2">
                    9.1 The Lessor must immediately remedy any defects that occur or exist in the rental object itself,
                    unless these defects have been culpably caused by the Lessee or by persons to whom the Lessee has
                    permitted use of the parking space and the Lessor has been informed of these defects by the Lessee.
                    The Lessor shall be liable for any damage caused by the failure to remedy the defects immediately.
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    9.2 The Lessor shall also be liable for all damage incurred by the Lessee as a result of the
                    Lessor’'s failure to comply with his contractual or statutory obligations, unless the Lessor can
                    only be accused of simple negligence in this respect. However, the Lessor shall be liable for
                    damages resulting from injury to life, limb or health even if the Lessor can only be accused of
                    simple negligence.
                </span>
            </p>
            <p className="c0">
                <span className="c3">
                    9.3 The Lessor shall ensure that booked pitches are available. In individual cases, however, it is
                    possible that no parking space is available despite a valid booking. In such cases, the tenant has
                    an extraordinary right of termination, unless the restriction on the usability of the parking space
                    is only minor in terms of time. In addition, there is a pro rata entitlement to reimbursement of
                    payments for the period of non-availability. The lessor shall only be liable for further claims
                    (e.g. compensation, loss of profit, indirect damage, third-party claims) if the unavailability was
                    caused by gross negligence or intent on the part of the lessor.
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    10. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Maximum parking period and contractual penalty
                    for non-compliance
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    10.1 By concluding the rental agreement, the Lessee undertakes to comply with the agreed rental
                    period. For the purposes of this Section 10, the agreed rental period shall be the rental period
                    booked by the Tenant on the booking platform as well as the maximum free parking period, if offered
                    on the managed space.
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    10.2 In the event that the Tenant exceeds the agreed rental period without authorization, the Lessee
                    shall owe the rent that would have been incurred for the actual rental period in addition to the
                    agreed rent. Section 10.3 remains unaffected by this.
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    10.3 In the event that the Lessee exceeds the agreed rental period without authorization or parks
                    their vehicle in a reserved parking space or in a marked no-parking zone, the Lessee shall owe the
                    contractual penalty specified on the Platform at the time of booking. This includes VAT.
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    10.4 If the booking is exceeded by 24 hours, the contractual penalty specified at the time of
                    booking shall be increased by the contractual penalty specified at the time of booking for each day
                    or part thereof. This applies up to an upper limit of EUR 750 (incl. VAT). The Lessor reserves the
                    right to claim any additional expenses incurred in connection with the collection of the contractual
                    penalty.
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    10.5 In the case of vehicles with foreign license plates, additional administrative expenses will be
                    charged due to the difficulty in determining the identity and recovering the forfeited contractual
                    penalty, but only up to a maximum amount of EUR 20 plus VAT.{' '}
                </span>
            </p>
            <p className="c0">
                <span className="c3">
                    10.6 After requesting the keeper data from the competent authorities, the Hirer will be invoiced for
                    the claim under 10.2 and 10.3. The claims are due for payment immediately after invoicing.{' '}
                </span>
            </p>
            <p className="c0">
                <span className="c2">11.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; General regulations</span>
            </p>
            <p className="c0">
                <span className="c3">
                    11.1 The law of the Federal Republic of Germany shall apply. If the Lessee is a consumer, this shall
                    not apply with regard to such provisions that are mandatory under the law that would be applicable
                    without this clause (i.e. usually the law of the country where the consumer has his main residence)
                    and from which no deviation may be made by agreement.{' '}
                </span>
            </p>
            <p className="c0">
                <span className="c2">
                    11.2 If the Lessee is an entrepreneur, has no general place of jurisdiction in Germany or in another
                    EU member state, has moved his permanent residence abroad after conclusion of the contract or his
                    place of residence or habitual abode is not known at the time the action is filed, the place of
                    jurisdiction for all disputes arising from this contractual relationship shall be Munich.{' '}
                </span>
            </p>
            <p className="c0">
                <span className="c3">
                    11.3 Intended amendments to the GTC shall be sent to the Lessee by e-mail at least one month before
                    the planned amendment, including notification of the planned date of entry into force. The amended
                    GTC shall become part of the contract with the Tenant's consent. The Lessor reserves the right to
                    terminate the contract with a notice period of six weeks to the end of the month if the Lessee does
                    not give its consent.{' '}
                </span>
            </p>
            <p className="c0">
                <span className="c3">
                    11.4 The EU Commission provides an online platform for online dispute resolution (ODR platform). It
                    can be accessed via the link{' '}
                </span>
                <span className="c3 c9">
                    <a className="c5" href="https://ec.europa.eu/consumers/odr/">
                        http://ec.europa.eu/consumers/odr/
                    </a>
                </span>
                <span className="c2">
                    . Neither the landlord nor Wemolo as an intermediary are obliged or willing to participate in an
                    alternative dispute resolution procedure before a consumer arbitration board.
                </span>
            </p>
            <p className="c0 c7">
                <span className="c1" />
            </p>
            <p className="c7 c8">
                <span className="c12 c6 c13" />
            </p>
        </>
    )
}

export default AgbEN
